import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getCPRTokenEncryption, getFAFTokenEncryption, getTokenEncryption } from "../../utilities/API/supertokenServices";
import { CASE_AK_VALUE, CPR_AK_VALUE, FAF_AK_VALUE, PARTNER_AK_VALUE } from "../../constant/Constants";

export const getTokenService = createAsyncThunk(
    'partnerToken', getTokenEncryption
)

export const getCPRTokenService = createAsyncThunk(
    'cprToken', getCPRTokenEncryption
)

export const getFAFTokenService = createAsyncThunk(
    'fafToken', getFAFTokenEncryption
)

const initialState = {
    loader: false
}

const getTokenSlice = createSlice({
    name: 'token',
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(getTokenService.pending, (state, action) => {
                state.loader = true
            })
            .addCase(getTokenService.fulfilled, (state, action) => {
                PARTNER_AK_VALUE.value = action?.payload?.response || "--"
                CASE_AK_VALUE.value = action?.payload?.response || "--"
            })
            .addCase(getTokenService.rejected, (state, action) => {
            })

            .addCase(getCPRTokenService.pending, (state, action) => {
                state.loader = true
            })
            .addCase(getCPRTokenService.fulfilled, (state, action) => {
                CPR_AK_VALUE.value = action?.payload?.response || "--"
            })
            .addCase(getCPRTokenService.rejected, (state, action) => {
            })

            .addCase(getFAFTokenService.pending, (state, action) => {
                state.loader = true
            })
            .addCase(getFAFTokenService.fulfilled, (state, action) => {
                FAF_AK_VALUE.value = action?.payload?.response || "--"
            })
            .addCase(getFAFTokenService.rejected, (state, action) => {
            })
    }
}
)

export default getTokenSlice.reducer